import React, { FC, ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Link from 'next/link';
import { PackageItem, PackageType } from 'sections/Membership/types';
import { activeIcon, notActiveIcon } from 'sections/Membership/svg';
import CustomTooltip from 'sections/Membership/components/Tooltip';
import styles from 'sections/Membership/components/PackageItem/PackageItem.module.scss';

const cn = classNames.bind(styles);

interface PackageItemElementProps {
  item: PackageItem;
  packageType: PackageType;
};

const Render = {
  title: (item: PackageItem) => {
    if (item.url) {
      return <Link href={item.url as Route} target="_blank">{item.title}</Link>;
    } else {
      return item.title;
    }
  },
  tooltip: (item: PackageItem) => {
    if (item.tooltipActive) {
      return (
        <div className={cn('package-item__tooltip-box')}>
          <CustomTooltip
            title={item.tooltipDescription}
            disableInteractive
            arrow
          >
            <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.1875 2C5.66565 2 2 5.66565 2 10.1875C2 14.7094 5.66565 18.375 10.1875 18.375C14.7094 18.375 18.375 14.7094 18.375 10.1875C18.375 5.66565 14.7094 2 10.1875 2ZM10.1875 16.7375C6.57582 16.7375 3.6375 13.7992 3.6375 10.1875C3.6375 6.57582 6.57582 3.6375 10.1875 3.6375C13.7992 3.6375 16.7375 6.57582 16.7375 10.1875C16.7375 13.7992 13.7992 16.7375 10.1875 16.7375ZM11.5521 12.9167H11.0063V9.91458C11.0063 9.46257 10.6395 9.09583 10.1875 9.09583H9.09583C8.64382 9.09583 8.27708 9.46257 8.27708 9.91458C8.27708 10.3666 8.64382 10.7333 9.09583 10.7333H9.36875V12.9167H8.82292C8.3709 12.9167 8.00417 13.2834 8.00417 13.7354C8.00417 14.1874 8.3709 14.5542 8.82292 14.5542H11.5521C12.0041 14.5542 12.3708 14.1874 12.3708 13.7354C12.3708 13.2834 12.0041 12.9167 11.5521 12.9167ZM10.1875 8.00417C10.7904 8.00417 11.2792 7.51537 11.2792 6.9125C11.2792 6.30956 10.7904 5.82083 10.1875 5.82083C9.58456 5.82083 9.09583 6.30956 9.09583 6.9125C9.09583 7.51537 9.58456 8.00417 10.1875 8.00417Z"
                fill="#9EA9B9"
              />
            </svg>
          </CustomTooltip>
        </div>
      )
    } else {
      return null;
    }
  },
};

const PackageItemElement: FC<PackageItemElementProps> = ({ item, packageType }): ReactElement => {
  return (
    <li className={cn('package-item')}>

      <div className={cn('package-item__icon-box')}>
        {item.iconType === 'checked' ? activeIcon() : notActiveIcon()}
      </div>

      <div className={cn('package-item__text-content')}>
        <div className={cn('package-item__name', packageType, { 'disabled': item.iconType === 'unchecked' })}>
          {Render.title(item)}
          {Render.tooltip(item)}
        </div>
      </div>

    </li>
  );
};

export default PackageItemElement;